import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/widgets/shoutouts/v1/:uuid",
            name: "shoutouts",
            component: () => import("./views/Shoutouts.vue"),
        },
        {
            path: "/widgets/timer/v1/:uuid",
            name: "timer",
            component: () => import("./views/Timer.vue"),
        },

        {
            path: "/enterprise/poll/v1/maddy",
            name: "enterprise poll",
            component: () => import("./views/Custom/Maddy/Poll.vue"),
        },
        {
            path: "/enterprise/timer/v1/maddy",
            name: "enterprise timer",
            component: () => import("./views/Custom/Maddy/Timer.vue"),
        },
        {
            path: "/enterprise/social/v1/maddy",
            name: "social media",
            component: () => import("./views/Custom/Maddy/SocialMedia.vue"),
        },
        {
            path: "/enterprise/shoutouts/v1/maddy",
            name: "maddy shoutouts",
            component: () => import("./views/Custom/Maddy/Shoutouts.vue"),
        },
        {
            path: "/enterprise/shopify/v1/maddy",
            name: "maddy shopify",
            component: () => import("./views/Custom/Maddy/Shopify.vue"),
        },
        {
            path: "/enterprise/giveaway/v1/maddy",
            name: "maddy giveaway",
            component: () => import("./views/Custom/Maddy/Giveaway.vue"),
        },
        {
            path: "/enterprise/countdown/v1/maddy",
            name: "maddy countdown",
            component: () => import("./components/custom/maddy/Countdown.vue"),
        },
    ],
});
